<form>
  <div class="form-group">
    <label class="d-block">
      <input type="text" class="form-control" [placeholder]="'Email'">
    </label>
  </div>
  <div class="form-group">
    <button class="btn btn-primary btn-block btn-raised" type="submit">
      <span>Reset Password</span>
    </button>
  </div>
  <a [routerLink]="['/auth/login']">Remember Password? Log in here!</a>
</form>
